import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

export const toastMessage = (message: string, type: string) => {
  switch (type) {
    case "success":
      toast.success(message, {
        className: "pw-toast-success",
      });
      break;

    case "error":
      toast.error(message, {
        className: "pw-toast-error",
      });
      break;

    case "info":
      toast.info(message, {
        className: "pw-toast-info",
      });
      break;

    case "warning":
      toast.warn(message, {
        className: "pw-toast-warning",
      });
      break;

    default:
      toast(message, {
        className: "pw-toast-success",
      });
      break;
  }
};
export const openWindow = (message: string) => {
  window.open(message, "_blank");
};
export const parseDate = (message: string) => {
  return message
    ? new Date(message)?.toString().split(" ").slice(0, 5).join(" ")
    : "-";
};
export const getYearFromDate = (date: string) => {
  const Dates = new Date(date);
  return Dates.getFullYear();
};
export const parseDateMonth = (message: string) => {
  let dateList = new Date(message)?.toString().split(" ").slice(0, 5);
  return message ? dateList[1] + " " + dateList[3] : "-";
};
export const PUBLIC_URL = window.location.origin + "/";
export const zeroPad = (num: number, places: number) =>
  String(num).padStart(places, "0");
export const addChildrenAtKey = (
  object: any,
  key: string,
  value: number,
  children: any
) => {
  if (Object.prototype.toString.call(object) === "[object Array]") {
    object.forEach((eachChild: any) => {
      addChildrenAtKey(eachChild, key, value, children);
    });
  } else if (object) {
    if (object[key] === value) {
      object["children"] = children;
    } else if (object.children?.length) {
      object.children.forEach((eachChild: any) => {
        addChildrenAtKey(eachChild, key, value, children);
      });
    }
  }
};

export const downloadXLSFile = async (url: string) => {
  axios({
    url: url + "?v=1", //your url
    method: "GET",
    responseType: "blob", // important
    headers: {
      "x-api-key": "zg6W6IxiAK6n4JFqkF7Yi8x4q641qp4434bAEFC0",
    },
  })
    .then((response) => {
      // create file link in browser's memory
      const href = URL.createObjectURL(response.data);

      // create "a" HTML element with href to file & click
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", "sample" + new Date() + ".xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    })
    .catch((e) => {
      toastMessage(e.data.response.message, "error");
    });
};
export const removeDuplicateObjects = (array: any[], property: string) => {
  const uniqueIds: any[] = [];

  const unique = array.filter((element) => {
    const isDuplicate = uniqueIds.includes(element[property]);

    if (!isDuplicate) {
      uniqueIds.push(element[property]);

      return true;
    }

    return false;
  });

  return unique;
};
export const fileTypeMatch = (
  fileType: string,
  matchWith: string,
  errorMessage: string
) => {
  const matchResult = new RegExp(fileType).test(matchWith);
  if (!matchResult && errorMessage) {
    toastMessage(errorMessage, "error");
  }
  return matchResult;
};
export const multiSourceCategories = [11, 13, 18, 19, 20, 21, 22, 23, 25];
export const isMultiSources = (eachPreference: any) => {
  return true;
};
export const specialRound = (value: any) => {
  return value > 1
    ? Math.round(value)
    : value === 0 || isNaN(value)
    ? 0
    : parseFloat(value)?.toFixed(2);
};
export const specialFloat = (value: number) => {
  return Math.round(value * 100) / 100;
};
export const convert2Float = (value: string) => {
  return Math.round(parseFloat(value) * 100) / 100;
};
export const dateParser = (date: any) =>
  new Date(parseDate(date))
    ?.toString()
    .split(" ")
    .slice(0, 5)
    .join(" ")
    .substring(4, 21) + " hrs";

export const dateParserWithoutTime = (date: any) =>
  new Date(parseDate(date))
    ?.toString()
    .split(" ")
    .slice(0, 5)
    .join(" ")
    .substring(4, 15);

export const dateParserWithoutTimeAndDate = (date: any) => {
  const parsedDate = new Date(parseDate(date));
  const month = parsedDate.toLocaleString("default", { month: "short" });
  const year = parsedDate.getFullYear();
  return `${month} ${year}`;
};

export const graphRoundOff = (value: any) => {
  if (value >= 1000000000) {
    return [value / 1000000000, "B"];
  } else if (value >= 1000000) {
    return [value / 1000000, "M"];
  } else if (value >= 10000) {
    return [value / 1000, "K"];
  } else {
    return [value, ""];
  }
};

export const checkPermissions = (
  userPermissions: string[],
  permissions: string[]
): boolean => {
  const hasPermission = userPermissions.every((permission: string) =>
    permissions.includes(permission)
  );

  return hasPermission;
};

export const round = (value: any) => {
  return parseFloat(value)?.toFixed(2);
};

export const checkSubscriptionPermission = (
  requiredPermissions: any,
  allFeaturesPermissionsList: any,
  count?: number,
  allAddonPermissions?: any
): boolean => {
  if (!requiredPermissions?.length) {
    return true;
  }
  let hasPermission = false;
  let usageLimit = 0;
  allFeaturesPermissionsList.forEach((item: any) => {
    if (item.name === requiredPermissions) {
      hasPermission = true;
      if (item.usageLimit) {
        usageLimit += item.usageLimit;
      }
      // if (item.usageLimit === null || (count && count < item.usageLimit)) {
      //   hasPermission = true;
      // }
    }
  });
  if (allAddonPermissions?.length) {
    allAddonPermissions.forEach((eachAddon: any) => {
      if (eachAddon.name === requiredPermissions && eachAddon.usage_limit) {
        usageLimit += eachAddon.usage_limit * eachAddon.quantity;
      }
    });
  }
  if (
    count != null &&
    count !== undefined &&
    usageLimit !== null &&
    usageLimit <= count
  ) {
    hasPermission = false;
  }
  return hasPermission;
};

export const checkSubscriptionLimit = (
  requiredPermissions: any,
  allFeaturesPermissionsList: any,
  allAddonPermissions: any,
  removedAddonQty?: number
): number => {
  let usageLimit: number = 0;
  allFeaturesPermissionsList.forEach((item: any) => {
    if (item.name === requiredPermissions && item.usageLimit) {
      usageLimit += item.usageLimit;
    }
  });
  if (allAddonPermissions?.length) {
    allAddonPermissions.forEach((eachAddon: any) => {
      if (eachAddon.name === requiredPermissions && eachAddon.usage_limit) {
        usageLimit +=
          eachAddon.usage_limit *
          (eachAddon.quantity - (removedAddonQty ? removedAddonQty : 0));
      }
    });
  }
  return usageLimit;
};

export const isObjectsEqual = (obj1: any, obj2: any): boolean => {
  const k1 = Object.keys(obj1);
  const k2 = Object.keys(obj2);
  let isEqual = true;
  k1.forEach((e: any) => {
    if (obj1[e] != obj2[e]) {
      isEqual = false;
    }
  });
  return k1.length === k2.length && isEqual;
};

export const validateInputNumber = (e: any) => {
  console.log(e?.code);
  if (
    e?.code === "ArrowDown" ||
    e?.code === "ArrowUp" ||
    e?.code === "Minus" ||
    e?.code === "KeyE"
  ) {
    e.preventDefault();
  }
};
